import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import PublicRoutes from "./router";
import Boot from "./redux/boot";
import AppProvider from "./AppProvider";
import MaterialLayout from "./hoc/materialLayout";

function App(auth) {
  useEffect(() => {
    document.title = process.env.REACT_APP_APPNAME;
  }, []);

  return (
    <MaterialLayout>
      <Provider store={store}>
        <AppProvider>
          <Router>
            <Switch>
              <PublicRoutes isAuthenticated={auth} />
            </Switch>
          </Router>
        </AppProvider>
      </Provider>
    </MaterialLayout>
  );
}

Boot()
  .then((auth) => App(auth))
  .catch((error) => {});

export default App;
